"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  headingLarge: _propTypes["default"].string,
  headingSmall: _propTypes["default"].string,
  logoURL: _propTypes["default"].string,
  backgroundImage: _propTypes["default"].shape({
    altText: _propTypes["default"].string,
    image: _propTypes["default"].string
  }),
  mobileImage: _propTypes["default"].shape({
    altText: _propTypes["default"].string,
    image: _propTypes["default"].string
  }),
  textBlockAlignment: _propTypes["default"].string || null,
  subtitle: _propTypes["default"].string,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  mksTagId: _propTypes["default"].string,
  ctas: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    link: _propTypes["default"].string,
    linkOriginal: _propTypes["default"].string,
    selectActionType: _propTypes["default"].string || null,
    openNewTab: _propTypes["default"].bool,
    backgroundCTA: _propTypes["default"].string
  }))
});
var _default = exports["default"] = PROP_TYPES;